export default {
  CREATE: `Créer un département`,
  DELETE_BUTTON: {
    TITLE: `Supprimer le département`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer ce département ?`,
    PRIMARY_ACTION: `Supprimer le département`
  },
  LIST: {
    TITLE: `Liste des départements`
  },
  TRANSFER_PHONE: `Numéro de transfert (pour les appels d'absence)`,
  CSV_EXPORT_NAME: `export_departements_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Création d'un département`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'un département`,
      SUMMARY: ``
    },
    NAMEFR: {
      LABEL: `Nom français du département`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom français pour le département`
    },
    NAMEEN: {
      LABEL: `Nom anglais du département`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom anglais pour le département`
    },
    CODE: {
      LABEL: `Code d'importation`,
      DESCRIPTION: `Le code d'importation sert à pouvoir assigner des départements à d'autres ressources avec les outils d'importation.`,
      PLACEHOLDER: `Entrez le code d'importation`
    },
    TRANSFERPHONE: {
      PHONENUMBER: {
        LABEL: `Numéro de téléphone`,
        DESCRIPTION: `Ce numéro permettera de transférér les appels d'absence vers un numéro unique au département.`,
        PLACEHOLDER: `Entrez le numéro de téléphone`
      },
      EXTENSION: {
        LABEL: `Extension`,
        DESCRIPTION: ``,
        PLACEHOLDER: `Entrez l'extension du numéro de téléphone`
      }
    },
    ATTENDANCE_CALL_TRANSFER: `Transfert d'appel`,
    NAME_FR_REQUIRED: `Le nom français du département est obligatoire.`,
    NAME_EN_REQUIRED: `Le nom anglais du département est obligatoire.`
  }
}
